import React from 'react';
import { PropTypes, describe } from 'react-desc';
import styled from 'styled-components';
import { truncate, color, border } from '@elliemae/ds-system';
import { CustomCard } from './Card.js';
import '@elliemae/ds-header';
import '@elliemae/ds-truncated-tooltip-text';
import './components.js';
import '@elliemae/ds-grid';

var Group = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1y2lfoo-0"
})(["display:flex;flex-direction:column;width:100%;max-width:100%;", "{border-top:none;}", ""], CustomCard, function (_ref) {
  var theme = _ref.theme,
      withTopBorder = _ref.withTopBorder;
  return withTopBorder ? "border-top: ".concat(theme.colors.neutral['100']) : '';
});
var GroupTitle = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-1y2lfoo-1"
})(["", ""], truncate());
var TitleWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1y2lfoo-2"
})(["display:flex;justify-content:space-between;padding:0 ", ";font-size:12px;", ";font-weight:", ";background-color:", ";border-top:", ";line-height:24px;"], function (props) {
  return props.theme.space.xs;
}, color('neutral', '700'), function (props) {
  return props.theme.fontWeights.semibold;
}, function (props) {
  return props.theme.colors.neutral['080'];
}, function (props) {
  return border(props.theme.colors.neutral['080']);
});
var Items = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1y2lfoo-3"
})(["display:flex;flex-direction:column;"]);

var CardGroup = function CardGroup(_ref2) {
  var children = _ref2.children,
      title = _ref2.title,
      action = _ref2.action;
  return /*#__PURE__*/React.createElement(Group, {
    withTopBorder: !title
  }, !!title && /*#__PURE__*/React.createElement(TitleWrapper, null, /*#__PURE__*/React.createElement(GroupTitle, null, title), action), /*#__PURE__*/React.createElement(Items, null, children));
};

var cardgroupProps = {
  /**
   * Card items
   */
  children: PropTypes.element.isRequired.description('Card items'),

  /**
   * Title of the group
   */
  title: PropTypes.string.isRequired.description('Title of the group'),

  /**
   * Right addon action
   */
  action: PropTypes.element.description('Right addon action')
};
CardGroup.propTypes = cardgroupProps;
var DSCardGroupWithSchema = describe(CardGroup);
DSCardGroupWithSchema.propTypes = cardgroupProps;

export default CardGroup;
export { CardGroup, DSCardGroupWithSchema };
//# sourceMappingURL=Group.js.map
